import MultipleChoiceValidator from './MultipleChoice/multipleChoiceValidator'
import MultipleAnswerValidator from './MultipleAnswer/multipleAnswerValidator'
import LueckentextValidator from './Lueckentext/lueckentextValidator'
import FreitextValidator from './Freitext/freitextValidator'
import ClickSvgValidator from './ClickSvg/clicksvgValidator'
import ClickMatrixValidator from './ClickMatrix/clickMatrixVallidator'
import DnDListSortValidator from "./DnDListSort/dndListSortValidator"
import DnDGroupSortValidator from "@features/QuestionTypes/DnDGroupSort/dndGroupSortValidator"
import DnD1u1ZuordnungenValidator from "@features/QuestionTypes/DnD1u1Zuordnungen/dnd1u1ZuordnungenValidator"
import CTWebertestValidator from '@features/QuestionTypes/CTWebertest/CTWebertestValidator'
import FrankfurterAdaptiveTestValidator from '@features/QuestionTypes/FrankfurterAdaptiveTest/FrankfurterAdaptiveTestValidator'
import MilitaryReactionTestValidator from '@features/QuestionTypes/MilitaryReactionTest/MilitaryReactionTestValidator'
import FlexibleReactionTestValidator from '@features/QuestionTypes/FlexibleReactionTest/FlexibleReactionTestValidator'
import PersonalityValidator from '@features/QuestionTypes/PersonalityTest/personalityValidator'
import ProfessionTypeValidator from '@features/QuestionTypes/ProfessionTypeTest/professionTypeValidator'
import NurtextValidator from '@features/QuestionTypes/NurText/nurtextValidator'


export default class ValidatorFactory
{
    static getFor(question)
    {
        if(question.isMultipleChoice())     return MultipleChoiceValidator
        if(question.isMultipleAnswer())     return MultipleAnswerValidator
        if(question.isLueckentext())        return LueckentextValidator
        if(question.isFreitext())           return FreitextValidator
        if(question.isClickSvg())           return ClickSvgValidator
        if(question.isClickMatrix())        return ClickMatrixValidator
        if(question.isDnDListSort())        return DnDListSortValidator
        if(question.isDnDGroupSort())       return DnDGroupSortValidator
        if(question.isDnD1u1Zuordnungen())  return DnD1u1ZuordnungenValidator
        if(question.isCTWebertest())                return CTWebertestValidator
        if(question.isFrankfurterAdaptiveTest())    return FrankfurterAdaptiveTestValidator
        if(question.isMilitaryReactionTest())       return MilitaryReactionTestValidator
        if(question.isFlexibleReactionTest())       return FlexibleReactionTestValidator
        if(question.isPersonalityTest())       return PersonalityValidator
        if(question.isProfessionTypeTest()) return ProfessionTypeValidator
        if(question.isNurText()) return NurtextValidator
    }
}
